export default __webpack_public_path__ + "static/media/ss10.82b7490f.jpg";